type dndStylesType = {
  item: string;
  itemPlaceholder: string;
  itemPreview: string;
  list: string;
  gridItemPlaceholder: string;
  isInitialPositionToDrop: string;
  gridItemPreview: string;
  withGridItemStrip: string;
  withGridItemStripRight: string;
};

declare const dndStyles: dndStylesType;

export default dndStyles;
